import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class vignetteStylesheetsEdit_template extends vnTemplate {
    protected monacoEditors: any = {};
    protected monacoLoaderPromise: any = null;

    protected getTemplateHtml(): string {
        return /*html*/ `
            <div class="w-form w-form-large">
                <div class="form-header">
                    <h3 class="form-title icon i-summary" data-bind="vtext: name">Vignette Stylesheet Editor</h3>
                    <button type="button"  data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2"></button>
                </div>
                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group">
                            <label class="form-label">Name</label>
                            <div class="w-input">
                                <input type="text" name="name" id="name"  class="input-text" data-bind="value: name">
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="form-label">Status</label>
                            <div class="w-input">
                                <select class="input-select" data-bind="value: idStatus">
                                    <option value="1">Draft</option>
                                    <option value="2">Completed</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="w-form-body">
                    <div class="form-body full-width">
                        <strong class="form-sub-title no-margin">Shared CSS</strong>
                        <div class="form-group">
                            <p class="form-text">This CSS is additive to each vignette's own CSS. On the public site it should be loaded once per page when any selected vignette is present.</p>
                            <textarea style="height: 400px" id="cssEditor" data-bind="textInput: css"></textarea>
                            <div id="cssMonacoEditor" style="height: 400px; border: 1px solid #ddd; display: none;"></div>
                        </div>
                    </div>
                </div>

                <div class="form-footer">
                    <button type="button" data-bind="event: { click: onClickCancel }" class="btn ">Cancel</button>
                    <button type="button" data-bind="event: { click: onClickSave }" class="btn highlight">Save</button>
                    <button type="button" data-bind="event: { click: onClickSaveAndStay }" class="btn highlight">Save & Stay</button>
                </div>
            </div>
            `;
    }

    protected initPartial(): void {
    }

    protected getTemplateName(): string {
        return "vignetteStylesheetsEdit_template";
    }

    protected buildViewModel(): any {
        const self = this;

        return {
            brand: ko.observable(""),
            id: ko.observable(""),
            name: ko.observable(""),
            cssValue: ko.observable(""),
            css: ko.pureComputed(this.cssComputed(self)),
            permissions: ko.observableArray(this.initPermissions(['vignette_stylesheets'])),
            isBrandOwner: ko.pureComputed(() => self.getIsBrandOwner()),
            brandOwner: ko.observable(null),
            idStatus: ko.observable('1'),
            onClickCancel: this.onClickCancel.bind(this),
            onClickSave: this.onClickSave.bind(this),
            onClickSaveAndStay: this.onClickSaveAndStay.bind(this),
        }
    }

    public getIsBrandOwner = (): boolean => {
        const vm = this.getTemplateViewModel();
        return (vm.brandOwner() && vm.brand()) ? vm.brandOwner().id == vm.brand() : false;
    }

    public onClickSave(data, event) {
        this.caller.saveStylesheet();
    }

    public onClickSaveAndStay(data, event) {
        this.caller.saveStylesheet('stay');
    }

    public onClickCancel() {
        this.caller.cancel();
    }

    protected cssComputed(self) {
        return {
            read: function () {
                return self.getTemplateViewModel().cssValue();
            },
            write: function (value) {
                self.getTemplateViewModel().cssValue(value);
                self.setMonacoEditorValue('css', value);
            }
        }
    }

    public setPermissions(permissions) {
        this.getTemplateViewModel().permissions(permissions);
    }

    public setStylesheet(stylesheet): void {
        this.getTemplateViewModel().id(stylesheet.id);
        this.getTemplateViewModel().name(stylesheet.name);
        this.getTemplateViewModel().brandOwner(stylesheet.brandOwner);
        this.setIdStatus(stylesheet.idStatus);
        this.setCss(stylesheet.css);
    }

    public getViewModelForRequest() {
        return {
            id: this.getTemplateViewModel().id(),
            name: this.getTemplateViewModel().name(),
            css: this.getTemplateViewModel().css(),
            idStatus: this.getIdStatus(),
        }
    }

    public setId(value): void {
        this.getTemplateViewModel().id(value);
    }

    public getId() {
        return this.getTemplateViewModel().id();
    }

    public setIdStatus(value): void {
        this.getTemplateViewModel().idStatus(String(value || '1'));
    }

    public getIdStatus(): number {
        return Number(this.getTemplateViewModel().idStatus());
    }

    public setCss(value): void {
        this.getTemplateViewModel().css(value);
    }

    public setBrand(brand): void {
        this.getTemplateViewModel().brand(brand);
    }

    public setupMonacoEditors(): void {
        setTimeout(() => {
            this.loadMonacoEditor().then((monaco) => {
                this.createMonacoEditor(monaco, 'css', 'css', 'cssEditor', 'cssMonacoEditor');
            }).catch(() => {
                this.showFallbackCodeEditors();
            });
        }, 0);
    }

    protected loadMonacoEditor(): any {
        const win: any = window as any;
        if (win.monaco && win.monaco.editor) {
            return Promise.resolve(win.monaco);
        }
        if (this.monacoLoaderPromise) {
            return this.monacoLoaderPromise;
        }

        this.monacoLoaderPromise = new Promise((resolve, reject) => {
            const configureLoader = () => {
                if (!win.require || typeof win.require.config !== 'function') {
                    reject();
                    return;
                }
                win.require.config({ paths: { vs: '/node_modules/monaco-editor/min/vs' } });
                win.require(['vs/editor/editor.main'], () => {
                    resolve(win.monaco);
                });
            };

            if (win.require && typeof win.require.config === 'function') {
                configureLoader();
                return;
            }

            const existingScript = document.querySelector('script[data-monaco-loader="true"]') as HTMLScriptElement;
            if (existingScript) {
                existingScript.addEventListener('load', configureLoader);
                existingScript.addEventListener('error', reject);
                return;
            }

            const script = document.createElement('script');
            script.src = '/node_modules/monaco-editor/min/vs/loader.js';
            script.setAttribute('data-monaco-loader', 'true');
            script.addEventListener('load', configureLoader);
            script.addEventListener('error', reject);
            document.body.appendChild(script);
        });

        return this.monacoLoaderPromise;
    }

    protected createMonacoEditor(monaco: any, key: string, language: string, textareaId: string, containerId: string): void {
        if (this.monacoEditors[key]) {
            this.setMonacoEditorValue(key, this.getTemplateViewModel()[key]());
            return;
        }

        const textarea = document.getElementById(textareaId) as HTMLElement;
        const container = document.getElementById(containerId) as HTMLElement;
        if (!textarea || !container) {
            return;
        }

        textarea.style.display = 'none';
        container.style.display = 'block';

        const editor = monaco.editor.create(container, {
            value: this.getTemplateViewModel()[key](),
            language: language,
            theme: 'vs-dark',
            lineNumbers: 'on',
            automaticLayout: true,
            minimap: { enabled: false },
            scrollBeyondLastLine: false,
            wordWrap: 'on',
            formatOnPaste: true,
            formatOnType: true,
        });

        editor.onDidChangeModelContent(() => {
            const value = editor.getValue();
            if (this.getTemplateViewModel()[key]() !== value) {
                this.getTemplateViewModel()[key](value);
            }
        });

        this.monacoEditors[key] = editor;
    }

    protected setMonacoEditorValue(key: string, value: string): void {
        const editor = this.monacoEditors[key];
        if (editor && editor.getValue() !== (value || '')) {
            editor.setValue(value || '');
        }
    }

    protected showFallbackCodeEditors(): void {
        const textarea = document.getElementById('cssEditor') as HTMLElement;
        const container = document.getElementById('cssMonacoEditor') as HTMLElement;
        if (textarea) {
            textarea.style.display = 'block';
        }
        if (container) {
            container.style.display = 'none';
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/vignetteStylesheetsEdit_template.ts